import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { MessaggioHome } from '@hm_app/@core/models/info';

@Injectable()
export class MessaggiHomeService {

    // Observable sources
    private messaggioHome = new BehaviorSubject<MessaggioHome>(null);

    // Observable streams
    messaggioHomeObservable = this.messaggioHome.asObservable();

    // Service message commands
    passMessaggioHome(messaggioHome: MessaggioHome) {
        this.messaggioHome.next(messaggioHome);
        // console.log(this.messaggioHome)
    }
}
